module.exports = __webpack_public_path__ + "img/loghi_large2021.2bac3fe0.png";